/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import LeaseListCard, { LeaseListQuery } from '../lease/LeaseListCard'
import { Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'
import { useRouteLoaderData } from '../../../../client/js/components/RouteLoaderData'
import CustomerBreadcrumb from './CustomerBreadcrumb'

function CustomerLeaseListPage () {
  const intl = useIntl()
  const params = useParams<{ id: string }>()
  const customer = useRouteLoaderData<Customer>()

  const [searchParams, setSearchParams] = useQueryParams()
  const searchQuery: LeaseListQuery = useMemo(() => ({
    ...searchParams,
    customerId: params.id
  }), [params.id, searchParams])

  const title = intl.formatMessage({
    id: 'rental_files',
    defaultMessage: 'Dossiers de location'
  })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <CustomerBreadcrumb
          customer={customer}
          title={title}
        />

        <LeaseListCard
          query={searchQuery}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default CustomerLeaseListPage
